import Typography from '@mui/material/Typography';
import React from 'react';

import { EmphasisColorMap } from './typography.const';
import { TypographyProps } from './typography.types';

/**
 * @deprecated Use `Display` or `Heading` from `common/src/components/TypographyV2`
 * (e.g. `<Display size="medium">` for marketing-hero scale, `<Heading size="large">` for page H1).
 */
export const H1: React.FC<TypographyProps> = ({ className, emphasis = 'high', ...props }) => {
  return (
    <Typography variant="h1" {...props} className={className} color={EmphasisColorMap[emphasis]} />
  );
};
